import React from 'react';
import PropTypes from 'prop-types';

import { BonusCard } from '@atlas/components';
import { Timer } from '@atlas/ui';

// Active bonuses get the live <Timer> (ticks every second, compact DD:HH:MM ->
// HH:MM:SS format); finished/expired ones keep the static date string (FT-8580).
const ProfileBonusCardWithLiveTimer = ({
  countdownEndMs,
  expiryDate: staticExpiryDate,
  ...bonusCardProps
}) => (
  <BonusCard
    {...bonusCardProps}
    expiryDate={
      countdownEndMs != null ? <Timer time={countdownEndMs} variant="compact" /> : staticExpiryDate
    }
  />
);

ProfileBonusCardWithLiveTimer.propTypes = {
  countdownEndMs: PropTypes.number,
  expiryDate: PropTypes.string,
};

export default ProfileBonusCardWithLiveTimer;
